




































import Vue from "vue";
import AttributeList from "@/components/molecules/AttributeList.vue";
import Attribute from "@/components/molecules/Attribute.vue";
import ButtonRound from "@/components/atoms/ButtonRound.vue";
import ImageView from "@/components/atoms/ImageView.vue";

export default Vue.extend({
  components: {
    AttributeList,
    Attribute,
    ButtonRound,
    ImageView,
  },
  props: {
    novelId: String,
    worldView: Object,
  },
  computed: {
    detail() {
      const detail = this.worldView.detail;
      const map = Object.assign(
        {},
        ...detail.map((d) => ({
          [d.name]: d.value,
        }))
      );

      return map;
    },
    additionalColumn() {
      return this.worldView.additionalColumn;
    },
    getWorldViewKey() {
      const {
        novelId,
        worldView: { worldViewId, image },
      } = this;
      if (image && image.startsWith("file:")) {
        return `file:novels/${novelId}/worldviews/${worldViewId}.jpg`;
      }
      return image;
    },
  },
});
